<template>
  <div>
    <template v-if="loading">
      <ophq-loading />
    </template>
    <template v-else>
      <headline code="titre-introduction"></headline>
      <ressource code="info-candidat" hide-if-empty></ressource>
      <div class="mt-6">
        <v-btn large color="primary" @click="init">Commencer</v-btn>
        <v-alert type="error" text max-width="700" class="mt-6" v-show="isError">
          <div class="black--text">
            <h3>{{ errorMessage }}</h3>
            <p class="mb-0">{{ errorDescription }}</p>
          </div>
        </v-alert>
      </div>
    </template>
  </div>
</template>

<script>
import { initFormulaire } from "@/plugins/services/sas"
import { mapGetters, mapMutations } from "vuex"

export default {
  props: {
    endpoint: { type: String, required: true },
    estFormulairePublic: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      isError: false,
      errorMessage: "Erreur",
      errorDescription: "Description de l'erreur."
    }
  },

  computed: {
    ...mapGetters(["contactId", "sas"])
  },

  methods: {
    ...mapMutations(["SET_SAS"]),

    init() {
      this.isError = false
      if (this.sas != undefined && this.sas.id) {
        this.$emit("next-step")
        return
      }
      this.loading = true
      let sasBuilderBuildParam = {}
      if (this.$route.query.type) {
        sasBuilderBuildParam.typeAdmission = this.$route.query.type
      }
      if (this.$route.query.formationId) {
        sasBuilderBuildParam.formationId = this.$route.query.formationId
      }
      if (this.$route.query.organisationId) {
        sasBuilderBuildParam.organisationId = this.$route.query.organisationId
      }

      initFormulaire(this.endpoint, this.contactId, sasBuilderBuildParam, this.estFormulairePublic)
        .then((res) => {
          if (res.data) {
            if (res.data.erreur) {
              this.isError = true
              this.errorMessage = res.data.message
              this.errorDescription = res.data.description
              //this.$router.push({ path: "/formulaire-deja-soumis" })
            } else {
              this.SET_SAS(res.data)
              this.$router.push({ path: this.$route.path, query: { ...this.$route.query, sasId: res.data.id } })
              this.$emit("next-step")
            }
          }
        })
        .catch((err) => {
          const status = err.response.status
          if (status === 401 || status === 400) {
            this.$router.push({ name: "Unauthorized" })
          } else if (status === 404) {
            this.$router.push({ name: "NotFound" })
          } else {
            this.$router.push({ name: "ErreurInterne" })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
